(ns iris.logs.views.post
  (:require
   [clojure.string :as str]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]
   [shadow.css :refer (css)]
   [iris.logs.subs :as logs-subs]
   [iris.subs :as subs]
   [iris.events :as events]
   [iris.hench :as hench]
   [iris.posts.subs :as posts-subs]
   [iris.firebase :as firebase]
   [iris.posts.views.moderator-bar :as moderator-bar]
   [iris.posts.views.post-screening-options :as pso]))


(defn- eid-link [eid raid-len]
  (when eid
    [:a {:href (str "/logs/eid/" eid)} (hench/eid-len-raid eid raid-len)]))

(defn- post-data-row [label value-el actions-el]
  [:div {:class "post-data-row"}
   [:div {:class "post-data-label"} label]
   [:div {:class "post-data-value"} value-el]
   [:div {:class "post-data-actions"} actions-el]])

(defn- post-data-full-row [label value-el]
  [:div {:class "post-data-row post-data-row-full"}
   [:div {:class "post-data-label"} label]
   [:div {:class "post-data-value"} value-el]])


(defn screening-badge [ss scope]
  (when scope
    (let [;; ss may be the full screening_status map keyed by ruid (post panel)
          ;; or already the individual status map (thread panel via screning-status sub)
          status     (if (contains? ss :n_enabled) ss (get ss (keyword scope)))
          n-enabled  (:n_enabled status 0)
          n-disabled (:n_disabled status 0)
          scope-enc  (js/encodeURIComponent scope)]
      [:div {:class "btn-group"}
       [:button {:class (css "btn btn-default" :pointer-events-none) :disabled true} "Screens:"]
       (if (and (zero? n-enabled) (zero? n-disabled))
         ;; not screened — show placeholder + create link
         [:<>
          [:button {:class (css "btn btn-default" :pointer-events-none) :disabled true}
           [:strong "not screened"]]
          [:a {:href  (str "/screening/create-new?scope=" scope-enc "&kind=full")
               :class "btn btn-primary"}
           [:span {:class "screening-create-label-full"} "Create new screen"]
           [:span {:class "screening-create-label-short"} "Create screen"]]]
         ;; screened — show enabled and/or disabled counts
         [:<>
          (when (pos? n-enabled)
            [:a {:href  (str "/screening?scope=" scope-enc)
                 :title "Click to see all screens with this scope"
                 :class "btn btn-danger"}
             [:strong (str n-enabled " enabled")]])
          (when (pos? n-disabled)
            [:a {:href  (str "/screening?scope=" scope-enc)
                 :title "Click to see all screens with this scope"
                 :class "btn btn-warning"}
             [:strong (str n-disabled " disabled")]])])])))

(defn- post-data-screening-badge [scope]
  (let [ss @(re-frame/subscribe [::posts-subs/screning-status scope])]
    [screening-badge ss scope]))


(defn post-data []
  (let [post     @(re-frame/subscribe [::logs-subs/post-data])
        raid-len @(re-frame/subscribe [::subs/raid-len])]
    (if (nil? post)
      [:div "Loading post data..."]
      [:<>
       [:h2 "Post Data" " " [:small "(raw)"]]
       [:div
        {:class "panel panel-default post-data-panel"}
        [:div {:class "post-data-grid"}
         [post-data-full-row "Submitted on:" (:iso_published post)]
         (when (= (:level post) 1)
           [post-data-full-row "Title:"
            [:pre {:class (css :whitespace-pre-wrap {:word-break "break-word"})}
             (get-in post [:content_raw :title])]])
         [post-data-full-row "Text:"
          [:pre {:class (css :whitespace-pre-wrap {:word-break "break-word"})}
           (get-in post [:content_raw :body])]]
         [post-data-full-row "Signature:" [:pre (get-in post [:content_raw :signed])]]
         (when-let [tags (seq (:tags post))]
           [post-data-full-row
            "Parsed Hashtags:"
            (for [tag tags]
              ^{:key tag}
              [:a {:href  (str "/h/" (subs tag 1))
                   :class "btn btn-default"}
               tag])])
         (when-let [refs (seq (:refs post))]
           [post-data-full-row
            "Parsed postrefs:"
            (for [ref refs
                  :let [[nick id] (str/split (subs ref 1) #"\+")]
                  :when (some? id)]
              ^{:key ref}
              [:a {:href  (str "/t/" id "#" nick)
                   :class "btn btn-default"}
               ref])])
         (when (and (= (:level post) 1)
                    (pos? (get-in post [:counts :replies] 0))
                    (:iso_active post))
           [post-data-full-row "Last reply:" (:iso_active post)])
         (let [author   (:author post)      
               uid-scope (some->> (:uid author) (str "="))
               a-eid    (get-in author [:eid :a_eid])
               m-eid    (get-in author [:eid :m_eid])
               l-eid    (get-in author [:eid :l_eid])
               m-ruid   @(re-frame/subscribe [::posts-subs/eid-metadata m-eid])
               l-ruid   @(re-frame/subscribe [::posts-subs/eid-metadata l-eid])
               rows     [["IP Address:"     [:a {:href (str "/logs/ip/" (:ip author))} (:ip author)]
                                             (str "^" (:ip author))]
                         ["Cookie:"         [eid-link (get-in author [:eid :c_eid]) raid-len]
                                             (get-in author [:eid :c_eid])]
                         ["BFP:"            [eid-link (get-in author [:eid :f_eid]) raid-len]
                                             (get-in author [:eid :f_eid])]
                         ["DFP:"            [eid-link (get-in author [:eid :d_eid]) raid-len]
                                             (get-in author [:eid :d_eid])]
                         ["Geo Location:"   [eid-link (get-in author [:eid :g_eid]) raid-len]
                                             (get-in author [:eid :g_eid])]
                         ["User Agent:"     (if a-eid
                                              [:a {:href (str "/logs/eid/" a-eid)} (:user_agent author)]
                                              [:span (:user_agent author)])
                                             a-eid]
                         ["MIME type:"      (when m-eid
                                              [:a {:href (str "/logs/eid/" m-eid)}
                                               (or (:orig_ruid m-ruid) (hench/eid-len-raid m-eid raid-len))])
                                             m-eid]
                         ["Accept Language:" (when l-eid
                                               [:a {:href (str "/logs/eid/" l-eid)}
                                                (or (:orig_ruid l-ruid) (hench/eid-len-raid l-eid raid-len))])
                                              l-eid]
                         ["User:"            (when uid-scope [:code uid-scope]) uid-scope]]]
           (for [[label id-el scope] rows]
             ^{:key label}
             [post-data-row label id-el [post-data-screening-badge scope]]))]]])))


(defn- reset-post-votes [post]
  (reagent/with-let [state (reagent/atom nil)]
    (let [ws     (:ws post)
          forum  (:board_slug post)
          thread (:thread post)
          nick   (:nick post)]
      (cond
        ;; idle
        (nil? @state)
        [:div {:class "btn-group btn-group-xs admin-buttons" :role "group"}
         (for [[label reset-type] [["+0" :up] ["-0" :down] ["+0/-0" :both]]]
           ^{:key reset-type}
           [:a {:class "admin-postedby btn btn-danger"
                :on-click (fn [e]
                            (.preventDefault e)
                            (reset! state {:loading true :type reset-type})
                            (-> (firebase/<p-get-post-votes ws forum thread nick)
                                (.then (fn [votes]
                                         (reset! state {:votes votes :type reset-type})))
                                (.catch (fn [_]
                                          (reset! state nil)))))}
            label])]

        ;; fetching
        (:loading @state)
        [:span "Loading votes..."]

        ;; confirmation
        (:votes @state)
        (let [{:keys [votes type]} @state
              u     (:u votes 0)
              d     (:d votes 0)
              new-u (if (= type :down) u 0)
              new-d (if (= type :up)   d 0)
              label (case type :up "+0" :down "-0" :both "+0/-0")]
          [:<>
           [:span {:style {:margin-right "8px"}}
            (str "Reset " label " (current: +" u " / -" d ")?")]
           [:div {:class "btn-group btn-group-xs"}
            [:a {:class "btn btn-danger"
                 :on-click (fn [e]
                             (.preventDefault e)
                             (-> (firebase/push-admin-votes-log
                                  {:post-ruid  (:id post)
                                   :forum-ruid (:forum post)
                                   :data       {:u new-u :d new-d}})
                                 (.then (fn [_]
                                          (re-frame/dispatch [::events/add-msg {:info (str "Votes reset: " (:id post))}])
                                          (reset! state nil)))
                                 (.catch (fn [err]
                                           (re-frame/dispatch [::events/add-msg {:error (.-message err)}])
                                           (reset! state nil)))))}
             "Confirm"]
            [:a {:class "btn btn-default"
                 :on-click (fn [e]
                             (.preventDefault e)
                             (reset! state nil))}
             "Cancel"]]])

        :else nil))))


(defn post-actions []
  (let [post  @(re-frame/subscribe [::logs-subs/post-data])
        roles @(re-frame/subscribe [::subs/roles])]
    (when post
      [:<>
       [:h2 "Post actions"]
       [:dl
        {:class "dl-horizontal"}
        [:dt "Moderate:"]
        [:dd
         (if (= (:level post) 1)
           [moderator-bar/op-btns post roles]
           [moderator-bar/reply-btns post roles])]
        [:dt {:class (css {:padding "12px 0"})} "Author:"]
        [:dd {:class (css {:padding "12px 0"})}
         [pso/post-screening-options post roles "/logs"]]
        [:dt "Reset post votes:"]
        [:dd [reset-post-votes post]]]])))
